import {
  DialogContent,
  Button,
  Dialog,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";
import React from "react";
import { makeStyles } from "@material-ui/core";
import palette from "../../theme/palette";
import typography, { pxToRem } from "../../theme/typography";
import Exclamation from "../../assets/images/icon/Exclamation";
import NewButton from "../../components/NewButton";
import useWidth from "../../utils/useWidth";
import CommonTypo from "../../components/CommonTypo";

interface IswitchInfluence {
  open: boolean;
  handleClose: any;
  handleSubmit: any;
  outcomeValueInput?: any;
}

const useStyles = makeStyles((theme) => ({
  categoryDialog: {
    "& .MuiDialog-container": {
      "& .MuiPaper-root": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "24px",
        background: palette.common.white,
        padding: 0,

        "& .MuiDialogContent-root": {
          padding: "0",
          overflowY: "unset",
        },

        "&. MuiDialogActions-root": {},
      },
    },
  },
  categoryDialogMobile: {
    "& .MuiDialog-container": {
      "& .MuiPaper-root": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "calc(100vw - 20px)",
        width: "calc(100vw - 20px)",
        borderRadius: "24px",
        background: palette.common.white,
        padding: 0,
        overflow: "hidden",
        margin: 0,
        "& .MuiDialogContent-root": {
          padding: "0",
          overflowY: "unset",
        },

        "&. MuiDialogActions-root": {},
      },
    },
  },
  categoryDialogAction: {
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    padding: "32px !important",
    gap: "12px",
    borderTop: "1px solid #F3F3F3",
    alignSelf: "stretch",
    "@media  (max-width: 726px) and (min-width: 100px)": {
      borderTop: `none`,
      flexDirection: "column",
      padding: "0px !important"
    },
  },
  paddingClassMobile: {
    padding: "32px !important",
    "@media  (max-width: 726px) and (min-width: 100px)": {
      padding: "0px !important",
    },
  },
}));
const ArchiveModal = (props: IswitchInfluence) => {
  const classes = useStyles();
  const width = useWidth()
  const isMobile = width < 768
  return (
    <Dialog
      open={props.open}
      onClose={props?.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`${width < 768 ? classes.categoryDialogMobile : classes.categoryDialog} dialogWrapper-mobileScreen`}
      sx={!isMobile ? {} : {
        "& .MuiPaper-root": {
          padding: "0px !important",
          borderRadius: "12px",
          gap: "24px",
          background: "#FFF",
          "@media  (max-width: 726px)": {
            padding: "32px 24px !important",
            gap: "16px",
            borderRadius: !isMobile ? "12px !important" : "12px 12px 0px 0px !important",
            display: "flex",
            flexDirection: "column",
            height: "max-content",
            maxHeight: "calc(100vh - 5%)",
            width: !isMobile ? "360px" : "100%",
          },

          // position: 'relative'
        },
      }}
    >
      <DialogContent id="alert-dialog-description">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "16px",
            alignSelf: "stretch",
          }}
          className={classes.paddingClassMobile}
        >
          {isMobile ? <CommonTypo size={24} fontWeight={700} color="var(--color-text-primary)" lineHeight={28.8}>
            Are you sure you want to archive {props?.outcomeValueInput}?</CommonTypo> : <Typography
              variant="h3"
              component="span"
              lineHeight="135% !important"
              sx={{
                color: palette.common.black,
                fontSize: `${pxToRem(24)} !important`,
                lineHeight: "120% !important",
                fontWeight: `600 !important`,
                fontFamily: `${typography.fontFamily} !important`,
              }}
            >
            Are you sure you want to archive {props?.outcomeValueInput}?
          </Typography>}
          {isMobile ? <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)" lineHeight={25.6}>
            You can always restore the metric, but after archiving it you will
            not be able to track it before undoing action</CommonTypo> : (
            <Typography
              variant="h3"
              component="span"
              lineHeight="150% !important"
              sx={{
                color: palette.common.black,
                fontSize: `${pxToRem(16)} !important`,
                fontWeight: `400 !important`,
              }}
            >
              You can always restore the metric, but after archiving it you will
              not be able to track it before undoing action
            </Typography>
          )}

        </Box>
      </DialogContent>
      {isMobile ? (
        <DialogActions className={classes.categoryDialogAction}>
          <NewButton
            buttonText="Do not archive"
            type="submit"
            onClick={props?.handleClose}
            variant="contained"
            extraSx={{
              width: "100%",
              border: `none`,
              height: "40px"
            }}
            typographySx={{
              "&.MuiTypography-root": {
                "@media  (max-width: 786px) and (min-width: 100px)": {
                  fontSize: `${pxToRem(16)} !important`,
                  lineHeight: "100% !important",
                  fontWeight: 600,
                  color: "var(--color-text-primary)"
                },
              },
            }}
            
          />
          <NewButton
            buttonText="Yes, archive"
            onClick={props?.handleSubmit}
            variant="outlined"
            extraSx={{
              width: "100%",
              border: `none`,
              height: "40px"
            }}
            typographySx={{
              "&.MuiTypography-root": {
                "@media  (max-width: 786px) and (min-width: 100px)": {
                  fontSize: `${pxToRem(16)} !important`,
                  lineHeight: "100% !important",
                  fontWeight: 600,
                  color: "var(--color-text-primary)"
                },
              },
            }}
          />
        </DialogActions>
      ) : (
        <DialogActions className={classes.categoryDialogAction}>
          <NewButton
            buttonText="Do not archive"
            type="submit"
            onClick={props?.handleClose}
            variant="contained"
          />

          <NewButton
            buttonText="Yes, archive"
            onClick={props?.handleSubmit}
            variant="outlined"
          />

        </DialogActions>
      )}
    </Dialog>
  );
};

export default ArchiveModal;
